export default "__VITE_ASSET__z7aoQm8X__"